<template>
  <v-card>
   <v-toolbar color="blue-grey white--text">
      <v-toolbar-title class="white--text">
        <span class="title">งานบริการวิชาการแก่สังคมและชุมชน</span>
        <div class="body-2">บุคลากรของสำนักงานไปบรรยายหรือจัดกิจกรรมให้หน่วยงานภายนอก</div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text"></v-toolbar-title>
    </v-toolbar> 

    <v-card-text>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-select
              :items="quarterItems"
              label="ไตรมาส"
              v-model="params.quarter"
              item-value="value"
              item-text="text"
              outline
              hide-details
            ></v-select>
          </v-flex>
          
          <v-flex xs12 md3>
            <v-text-field
              v-model="params.year"
              label="ปี"
              outline
              mask="####"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-slide-x-transition mode="out-in">
        <v-btn
          color="info"
          target="_new" 
          :href="printoutUrl"
          v-if="active"
        >
          <v-icon left dark>cloud_download</v-icon> ส่งออกข้อมูล
        </v-btn>
      </v-slide-x-transition>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '@/config/index'
import swal from 'sweetalert2'

export default {
  data () {
    return {
      disabled: true,
      loading: false,
      quarterItems: [
        {text: 'ไตรมาสที่ 1 (ตุลาคม-ธันวาคม)', value: 1},
        {text: 'ไตรมาสที่ 2 (มกราคม-มีนาคม)', value: 2},
        {text: 'ไตรมาสที่ 3 (เมษายน-มิถุนายน)', value: 3},
        {text: 'ไตรมาสที่ 4 (กรกฎาคม-สิงหาคม)', value: 4}
      ],
      params: {
        quarter: null,
        year: null
      }
    }
  },
  mounted () {},
  computed: {
    ...mapGetters ({
      token: 'token'
    }),
    printoutUrl () {
      return `${config.serverURI}/reports/printout/activity/genStaff?quarter=${this.params.quarter}&year=${this.params.year}&access_token=${this.token}`
    },
    active () {
      return this.params.quarter && this.params.year
    }
  },
  mounted () {},
  methods: {},
  watch: {}
}
</script>

<style scoped>
  .boxes {
    min-width: 400px;
  }
</style>


// WEBPACK FOOTER //
// src/components/reports/activity/genStaff/index.vue